import EditIcon from "@mui/icons-material/Edit";
import { IconButton, Tooltip } from "@mui/material";
import { Box } from "@mui/system";

const EditCommIcon = ({ handleClick }: { handleClick?: () => void }) => {
	return (
		<Box textAlign='end'>
			<Tooltip title='Edit'>
				<IconButton onClick={handleClick}>
					<EditIcon sx={{ cursor: "pointer" }} />
				</IconButton>
			</Tooltip>
		</Box>
	);
};

export default EditCommIcon;
